import { render } from "./LoadingStatus.vue?vue&type=template&id=ef2f496a"
import script from "./LoadingStatus.vue?vue&type=script&lang=js"
export * from "./LoadingStatus.vue?vue&type=script&lang=js"

import "./LoadingStatus.vue?vue&type=style&index=0&id=ef2f496a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__